export const defaultRiskData = [
  {
    question: 'Use of stop-loss',
    positiveLabel: 'Used',
    negativeLabel: 'Not Used',
    perCent: null,
  },
  {
    question: 'Predetermined risks',
    positiveLabel: 'Predetermined',
    negativeLabel: 'Not predetermined',
    perCent: null,
  },
  {
    question: 'Risk-Reward strategy',
    positiveLabel: 'Followed',
    negativeLabel: 'Not followed',
    perCent: null,
  },
  {
    question: 'Limited correlation',
    positiveLabel: 'Correlated transactions',
    negativeLabel: 'Uncorrelated transactions',
    perCent: null,
  },
  {
    question: 'Transaction size analysis',
    positiveLabel: 'Analysis made',
    negativeLabel: 'Analysis not made',
    perCent: null,
  },
]
